import { makeAutoObservable } from 'mobx';
import { TFloorApartments } from './types';
import { unityProviderStore } from '../unity.provider.store';
import { SceneState } from '../../../modules/scenetemplate/hooks/constants';
import { floorsStore } from '../../floors/floors.store';
import { constructionType } from '../../bookRealEstate/roomInfo';

class RealEstateStore {
  sceneState = '';

  buildingInfo: any;

  floorData: TFloorApartments;

  roomData: any;

  isLoading = false;

  showRooms = true;

  currentRoom: any = null;

  constrictionRoomData: any = null;

  bookingConfirmationData: any = null;

  constructor() {
    makeAutoObservable(this);
  }

  get isFloor() {
    return this.sceneState === SceneState[1] && !this.isLoading;
  }

  onReceiveBuildingData = (buildingInfo: string) => {
    const buildingData = JSON.parse(buildingInfo);
    this.buildingInfo = buildingData;
    return this.onElevator();
  };

  onElevator = () => {
    floorsStore.setVisibleElevatorBoard(true);
    floorsStore.setBuildingRooms(this.buildingInfo.bundleProperty);
  };

  setFloorData = (data: any) => {
    this.floorData = data;
  };

  onOpenFloor = async (floor: string) => {
    if (floor === 'G') {
      await this.onConstructLoadingPhase(1, 0)
      unityProviderStore.instance.SendMessage(
          'CopiaReactManager',
          'OpenConstructEnvironment',
      )
      return null
    }

    this.floorData = this.buildingInfo.bundleProperty[floor]

    unityProviderStore.instance.SendMessage(
        'CopiaReactManager',
        'OpenConstructFloor',
        JSON.stringify({ BuildingId: this.buildingInfo.id, FloorIndex: floor }),
    )
  }

  onReceiveFloorData = (floorData: string) => {
    this.floorData = JSON.parse(floorData);
    floorsStore.setSelectedFloor(this.floorData[0].apartmentFloor);
  };

  onReceiveRoomData = (roomData: any) => {    
    this.roomData = JSON.parse(roomData);
  };

  openEstateRoom = (data: any) => {
    unityProviderStore.instance.SendMessage(
      'CopiaReactManager',
      'OpenConstructRoom',
      JSON.stringify(data),
    );
  };

  setCurrentRoom = (data: any) => {
    this.currentRoom = data;
  };

  onHoverExit = (data: any) => {
    // console.log(data);
  };

  onReceiveConstructRoomData = (data: any) => {
    try {
      debugger;
      this.constrictionRoomData = JSON.parse(data);
    } catch (error) {
      console.log(error, data);
    }
  };

  onConstructLoadingPhase = async (opacity: number, scene: any) => {
    const flag = Boolean(opacity);
    this.sceneState = SceneState[scene];
    if (flag) {
      this.isLoading = true;
      await this.timer(scene);
    } else {
      this.isLoading = false;
    }
  };

  timer = (scene: any) => {
    return new Promise((resolve) => {
      const timerId = setTimeout(() => {
        clearTimeout(timerId);
        resolve(true);
        if (scene === 1 && window.location.pathname.includes('constructors'))
          this.onReceiveConstructRoomData(null);
        if (scene === 2 && window.location.pathname.includes('constructors'))
          this.onReceiveConstructRoomData(JSON.stringify(this.roomData));
      }, 500);
    });
  };

  setShowRooms = (state = !this.showRooms) => {
    this.showRooms = state;
  };

  setBookingConfirmationData = (data: any) => {
    this.bookingConfirmationData = data;
  };

  get roomSections() {
    const { constructorBundles } = unityProviderStore.roomData;
    return [
      {
        title: 'Apartment Information',
        info: [
          {
            title: 'Room Size',
            desc: `${this.constrictionRoomData.apartmentSquare} sqm`,
          },
        ],
      },
      {
        title: 'Building Information',
        info: [
          {
            title: 'Construction Type',
            desc: constructionType[constructorBundles[0][0].constructionType],
          },
          {
            title: 'Floors in the Building',
            desc: constructorBundles[0][0].floorNumber,
          },
          {
            title: 'Elevator',
            desc: constructorBundles[0][0].isElevator
              ? 'Available'
              : 'Not Available',
          },
        ],
      },
      // {
      //     title: "Description",
      //     info: [{
      //
      //     }]
      // }
    ];
  }

  getRoomInfo = (index: number) => {
    switch (index) {
      case 0:
        return [
          {
            title: '',
            desc: '',
          },
          {
            title: '',
            desc: '',
          },
          {
            title: '',
            desc: '',
          },
        ];
      case 1:
        return [
          {
            title: 'Construction Type',
            desc: '',
          },
          {
            title: 'Floors in the Building',
            desc: '',
          },
          {
            title: 'Elevator',
            desc: '',
          },
        ];
      case 2:
        return [
          {
            title: '',
            desc: '',
          },
          {
            title: '',
            desc: '',
          },
          {
            title: '',
            desc: '',
          },
        ];
      default:
        return [];
    }
  };

  removeRealEstate = (id: string) => {};
}

const realEstateStore = new RealEstateStore();
export default realEstateStore;
